import { FETCH_UI_METADATA } from '@/store/types/actions';
import { FULLSCREEN_SET, MINIMISE_NAVIGATION, SUBNAV_CHANGED, UI_METADATA_FETCHED } from '@/store/types/mutations';
import { apolloSdk } from '../../api/apollo';

const actions = {
  async [FETCH_UI_METADATA]({ commit }) {
    const { meta } = await apolloSdk.Meta();
    commit(UI_METADATA_FETCHED, meta);
  },
};

const mutations = {
  [FULLSCREEN_SET](state, isFullscreen) {
    state.isFullscreen = isFullscreen;
  },
  [SUBNAV_CHANGED](state, hasSubnav) {
    state.hasSubnav = hasSubnav;
  },
  [MINIMISE_NAVIGATION](state, isMinimised) {
    state.navigationMinimised = isMinimised;
  },
  [UI_METADATA_FETCHED](state, { hsIdToken, releaseNotesVersion }) {
    state.hsIdToken = hsIdToken;
    state.releaseNotesVersion = releaseNotesVersion;
  },
};

const state = {
  isFullscreen: false,
  hasSubnav: false,
  navigationMinimised: false,
  hsIdToken: null,
  releaseNotesVersion: null,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
